module.exports = __webpack_public_path__ + "static/media/scroll3_0.fbaec96f.png";